export default __webpack_public_path__ + "static/media/TISCO.0d662633.png";